<!-- <div class="modal fade" id="modaluploadnewversion" tabindex="-1"
	role="dialog"> -->
<div class="modal-dialog" [attr.role]="'document'">
	<div class="modal-content">
		<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
			<button class="btn btn-default-reverse btn-block btn-sm"
				[attr.data-dismiss]="'modal'" type="button" (click)="createForm();">Chiudi</button>
		</p>
		<div>
			<div class="col-sm-12 coldx">
        <h4>Sposta documento</h4>
        <ng-template [ngIf]="spostaDocumentoForm">

         
            <form #f="ngForm" [formGroup]="spostaDocumentoForm" (ngSubmit)="update();">
            <div class="row">
				      <div class="col-sm-4"></div>

                <div *ngIf="sezioniOptions.length > 0" comboModInput [control]="spostaDocumentoForm.controls['sezione']"
                  class="col-sm-4" [labelInput]="'Sezione'"
                    formControlName="sezione"
                    [mandatory]="true"
                    [optionsCombo]="sezioniOptions"
                    [labelOption]="'label'"
                    [objectReference]="request.tipoSezioneDestinazione"
                    (onReturn)="getDestinazione($event)"
                    >
                </div>

                <!-- <div comboModInput [control]="spostaDocumentoForm.controls['entity']" *ngIf="request.sezione.tipoSezione.id"
                  class="col-sm-6" [labelInput]="'Entit&agrave;'"
                  formControlName="entity"
                  [mandatory]="true"
                  [optionsCombo]="entityOptions"
                  [labelOption]="'label'"
                  [objectReference]="request.entity"
                  (onReturn)="request.entity=$event"
                  [(ngModel)]="request.sezione">
                </div> -->

				      <div class="col-sm-4"></div>
            </div>

            <div class="row">
              <p class="mandatory col-sm-12">
                <em>* Campi obbligatori</em>
              </p>
            </div>
            <div class="row">
              <p class="col-sm-3 col-xs-6">
                <button type="button" class="btn btn-outline-secondary btn-block"
                        (click)="createForm();">Reset</button>
              </p>
              <p
                submitButton [disabled]="!request.tipoSezioneDestinazione"
                class="col-sm-3 col-xs-6 col-sm-offset-6"
                [labelButton]="'Salva'"></p>
            </div>
          </form>
        </ng-template>
			</div>
		</div>
	</div>
</div>
<!-- </div> -->
